export const getWithholdingAmount = (percentage: number, netTotal: number, ivaTotal: number, type: string) => {
  const base = type === "ReteIva" ? ivaTotal : netTotal;
  return base * percentage / 100;
}
import { withholdingFamily, type TaxLike } from "@/utils/taxes";

export function resolveWithholdingAmount(
  withholding: TaxLike, net: number, iva: number, country?: string | null,
): number {
  if (withholding.tax_amount != null) return withholding.tax_amount;
  const base = withholding.taxable_amount ?? (withholdingFamily(withholding, country) === "ReteIva" ? iva : net);
  return base * (withholding.percentage ?? 0) / 100;
}
